import * as React from "react";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {ClaimReportingPopup} from "../../../../../components/claims/ClaimReportingPopup";
import { getSessionStorage, scrollToTop, setSessionStorage } from "../../../../../CommonFunctions";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {NextButton} from "../../../subscription/motor/motorClaims/NextButton";
import {RadioInput} from "../../../../../components/inputs/RadioInput";
import {FalconNavigatorHeader} from "@falcon/services";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IOtherClaimPage {
    urgentClaim: IUrgentClaim;
}

export interface IUrgentClaim {
    isUrgentClaim: boolean | null;
    showUrgentClaimPopup: boolean;
}

@authorize
export class OtherClaimPagePlain extends React.Component<IWithRouterProps, IOtherClaimPage> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps) {
        super(props);

        const urgentClaim = getSessionStorage("urgentClaim");

        this.state = {
            urgentClaim: urgentClaim !== null ? urgentClaim : {
                isUrgentClaim: null,
                showUrgentClaimPopup: false
            } as IUrgentClaim
        };
        this.pluginTemplates.setPageTitle("Make a car claim");
    }

    public componentDidMount(): void {
        scrollToTop();
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>

                <div className="page-contents">
                    <AllianzOnlineBadge/>
                    {this.state.urgentClaim.showUrgentClaimPopup &&
                        <ClaimReportingPopup title="Urgent claim reporting"
                             bodyTopParagraph={<p>If you're on the roadside, your vehicle is not drivable or any{' '}
                                 one has been injured please call our urgent claims number on</p>}
                             showModal={this.state.urgentClaim.showUrgentClaimPopup}
                             onModalHide={this.toggleModal}
                             id={"urgentClaimReporting"}
                             localPhoneNumber="08000 304 897"
                             abroadPhoneNumber="0120 284 8509"
                        />
                    }
                    <FalconNavigatorHeader back="/dashboard/pickAnnualMotorClaimKind" title="Make a car claim"/>
                    {this.renderClaimUrgentSection()}
                    <NextButton buttonId={"submitUrgentClaimPage"}
                                disabled={this.state.urgentClaim.isUrgentClaim == null?  true : this.state.urgentClaim.isUrgentClaim}
                                onClick={this.handleRedirect}/>
                    <BackButton isTop={false} link={"/dashboard/pickAnnualMotorClaimKind"}/>
                </div>

                <FalconFooter/>
            </React.Fragment>
        )
    }

    private renderClaimUrgentSection = (): React.ReactNode => {
        return (
            <div className="panel">
                <RadioInput label={<label>Is your claim urgent?</label>}
                    id="urgentClaim"
                    onChange={this.setUrgentClaim}
                    value={this.state.urgentClaim.isUrgentClaim!}
                    infoSection={this.renderUrgentClaimInfoSection()}
                    inlineDisplay={true}
                />
            </div>
        )
    };

    private renderUrgentClaimInfoSection(): React.ReactNode {
        return (
            <div className="info-button-panel">
                <p>
                    <span className="font-weight-semi-bold">Urgent claim: </span>
                    If you're on the roadside, your vehicle is not drivable or any one has been injured please call our urgent claims number on
                    <span className="font-weight-semi-bold">
                        <a href="tel:+44 8000 304 897" className="mb-4 no-underline text-blue-2" aria-label="Phone number +44 8000 304 897"> 08000 304 897</a>
                    </span>
                </p>
                <p>
                    <span className="font-weight-semi-bold">Non-urgent claim: </span>
                    If your vehicle is still drivable and no one has been injured then please use our online notification form
                </p>
            </div>
        )
    }

    private handleRedirect = (): void => {
        this.props.navigate("/dashboard/otherClaims/coverDetails");
    };

    private setUrgentClaim = (event: any): void => {
        const isClaimUrgent: boolean = event.target.value === "true";
        const urgentClaim: IUrgentClaim = {...this.state.urgentClaim};
        if (isClaimUrgent)  {
            urgentClaim.showUrgentClaimPopup = isClaimUrgent;
        }
        urgentClaim.isUrgentClaim = isClaimUrgent;
        this.setState({urgentClaim});
        setSessionStorage("urgentClaim", urgentClaim);
    };

    private toggleModal = (): void => {
        const urgentClaim: IUrgentClaim = {...this.state.urgentClaim};
        urgentClaim.showUrgentClaimPopup = !urgentClaim.showUrgentClaimPopup;
        this.setState({urgentClaim});
        setSessionStorage("urgentClaim", urgentClaim);
    };
}

export const OtherClaimPage = withRouter(OtherClaimPagePlain)
